import { getStatusByKey } from "src/components/StatusBadge/status";

/**
 * Maps API progress data to step details for the StepProgressBar component
 * @param {Array} apiData - Raw API data from progress details endpoint
 * @returns {Array} Transformed step data with label, status, name, and status_date
 */
export const mapApiDataToStepDetails = (apiData = []) => {
  if (!apiData) return [];
  return apiData.map((item, index) => {
    const statusConfig = getStatusByKey(item.status_key);

    let label = statusConfig?.display_name;

    if (item?.status_key === 2 && item?.approver_level !== null) {
      label = `${label} (Level ${item?.approver_level})`;
    }

    return {
      label,
      status: item?.status,
      name: item?.name,
      status_date: item?.status_date,
    };
  });
};

